import React, { Component } from "react";
import HomeComponent from './components/HomeComponent';
import "./assets/css/fontawesome.css";
import "./assets/css/templatemo-finance-business.css";
import "./assets/css/owl.css";


export class HomeContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the Home page
        }
    }

    render(){
        return(
            <HomeComponent/>
        )
    }
          
        
}

HomeContainer.defaultProps={

}
HomeContainer.propTypes = {

}

export default(HomeContainer);